export const postSort = (posts, sortDirection) => {
  let transformedPosts = posts;

  if (sortDirection === 'Alphabetical') {
    transformedPosts = transformedPosts.sort((a, b) => {
      if (a?.fields?.title < b?.fields?.title) return -1;
      return 1;
    });
  } else if (sortDirection === 'Reverse Alphabetical') {
    transformedPosts = transformedPosts.sort((a, b) => {
      if (a?.fields?.title > b?.fields?.title) return -1;
      return 1;
    });
  } else if (sortDirection === 'Publication Date Ascending') {
    transformedPosts = transformedPosts.sort((a, b) => {
      if ((!a?.fields?.publicationDate && b?.fields?.publicationDate) || a?.fields?.publicationDate < b?.fields?.publicationDate) return -1;
      if (a?.fields?.publicationDate && b?.fields?.publicationDate && a?.fields?.publicationDate > b?.fields?.publicationDate) return 1;
      return 0;
    });
  } else if (sortDirection === 'Publication Date Descending') {
    transformedPosts = transformedPosts.sort((a, b) => {
      if ((!a?.fields?.publicationDate && b?.fields?.publicationDate) || a?.fields?.publicationDate > b?.fields?.publicationDate) return -1;
      if (a?.fields?.publicationDate && b?.fields?.publicationDate && a?.fields?.publicationDate < b?.fields?.publicationDate) return 1;
      return 0;
    });
  }
  return transformedPosts;
};

export default postSort;
